import React from "react";
import * as ReactDOM from 'react-dom';
import App from './app';
document.addEventListener('DOMContentLoaded', (event) => {
    const rootElement = document.getElementById('quiz-root');
    if (rootElement) {
        ReactDOM.render(React.createElement(App, null), rootElement);
    }
});
